import { useContext } from "react"
import Loading from "../../components/Loading";
import { LabContext } from "../../context/labContext"
import { useNavigate } from "react-router-dom";

const LabsList = () => {

    const navigate = useNavigate();
    const { labs } = useContext(LabContext);

    if (labs === null) {
        return <Loading />;
    }

    if (labs.length === 0) {
        return <p>There area no any labs.. </p>;
    }

    const handleClick = (id) => {
        navigate(`/admin/lab/${id}`);
    }

    return (
        <div className="w-100 h-100">
            <p>lab list</p>
            <div className="row">
                {labs.map(lab => (
                    <div key={lab.id} className="col-md-3 col-12">
                        <div
                            onClick={() => handleClick(lab.id)}
                            className="card shadow">
                            <div
                                className="youtubeVideo text-center bg-dark py-5 d-flex justify-content-center align-items-center text-white">
                                <h5 className="card-title m-1">{lab.title}</h5>
                            </div>
                            <div className="card-body">
                                <p className="card-text">{lab.description.substr(0, 60)}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )

}
export default LabsList